import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import {
  BookingDataFromBookingNo,
  BookingDetailFromBookingNo,
  BookingDetailsFromBookingNoParams,
  BookingListingParams,
  BookingTrip,
  ResponseData,
} from "./common"

// API for get booking listing
export interface GetBookingListingRequest extends Partial<AxiosRequestConfig> {
  params: BookingListingParams
}

export interface GetBookingTripsResponseData extends ResponseData {
  data: BookingTrip[]
}

export interface GetBookingTripsResponse extends AxiosResponse {
  data: GetBookingTripsResponseData
}
export function getBookingListApi(
  axiosInstance: AxiosInstance,
): Promise<GetBookingTripsResponse> {
  return axiosInstance({
    method: "get",
    url: `/booking/user/bookings`,
    data: { isAuthTokenCheck: true },
  }) as Promise<GetBookingTripsResponse>
}

// API for get booking detail from bookingNo
export interface GetBookingDetailFromBookingNoRequest
  extends Partial<AxiosRequestConfig> {
  params: BookingDetailsFromBookingNoParams
}

export interface GetBookingDetailsParams {
  bookingNumber: string
}
export interface BookingDetailFromBookingNoResponseData extends ResponseData {
  data: BookingDataFromBookingNo
}
export interface BookingDetailFromBookingNoResponse extends AxiosResponse {
  data: BookingDetailFromBookingNoResponseData
}
export function getBookingDetailFromBookingNoApi(
  {
    params,
    method = "get",
    url = `/booking/getbookings/${params.bookingNo}`,
  }: GetBookingDetailFromBookingNoRequest,
  axiosInstance: AxiosInstance,
): Promise<BookingDetailFromBookingNoResponse> {
  return axiosInstance({
    method,
    url,
    data: { isAuthTokenCheck: true },
  }) as Promise<BookingDetailFromBookingNoResponse>
}

export interface BookingDataFromBookingNoResponseData extends ResponseData {
  data: BookingDetailFromBookingNo
}
export interface BookingDataFromBookingNoResponse extends AxiosResponse {
  data: BookingDetailFromBookingNoResponseData
}
export function getBookingDataFromBookingNoApi(
  {
    params,
    method = "get",
    url = `/booking/booking-data/${params.bookingNo}`,
  }: GetBookingDetailFromBookingNoRequest,
  axiosInstance: AxiosInstance,
): Promise<BookingDetailFromBookingNoResponse> {
  return axiosInstance({
    method,
    url,
    data: { isAuthTokenCheck: true },
  }) as Promise<BookingDetailFromBookingNoResponse>
}

export interface InviteStatusUpdateRequest extends Partial<AxiosRequestConfig> {
  params: {
    id: number
    status: string
  }
}

export function setInviteStatusUpdateApi(
  { params }: InviteStatusUpdateRequest,
  axiosInstance: AxiosInstance,
) {
  const url = `/split-payment`
  return axiosInstance({
    data: params,
    method: "post",
    url,
  })
}

export interface GetCountriesAndStatesListResponseData {
  code: string
  country: string
  name: string
  regex: string | null
  states: { name: string; stateCode: string }[]
  cityLabel: string | null
  stateLabel: string | null
  zipLabel: string | null
  isStateOptional: boolean
  availablePayments?: string[]
}
export interface GetCountriesAndStatesListResponse extends AxiosResponse {
  data: GetCountriesAndStatesListResponseData[]
}

export function getCountriesAndStatesList(
  axiosInstance: AxiosInstance,
): Promise<GetCountriesAndStatesListResponse> {
  const method = "get"
  const url = `system/countrylist`
  return axiosInstance({
    method,
    url,
  }) as Promise<GetCountriesAndStatesListResponse>
}
